import { RootState } from '@/shared/store'
import { createSelector } from '@reduxjs/toolkit'

// Get the unit of measure from the client preset
export const selectUomWeight = createSelector(
  [state => state],
  (state: RootState) => state.user.client?.UomVolume || '',
)
